"use strict";

var _slicedToArray = require("/Users/Pablo/Nnodes/fundacion_tests_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDragLayer = useDragLayer;

var _react = require("react");

var _useDragDropManagerJs = require("./useDragDropManager.js");

var _useCollectorJs = require("./useCollector.js");

function useDragLayer(collect) {
  var dragDropManager = (0, _useDragDropManagerJs).useDragDropManager();
  var monitor = dragDropManager.getMonitor();

  var _useCollector = (0, _useCollectorJs).useCollector(monitor, collect),
      _useCollector2 = _slicedToArray(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  (0, _react).useEffect(function () {
    return monitor.subscribeToOffsetChange(updateCollected);
  });
  (0, _react).useEffect(function () {
    return monitor.subscribeToStateChange(updateCollected);
  });
  return collected;
}